export const getSizesFromAttributes = (attributes = []) => {
  // if (attributes?.length) {
  //   if (attributes.length > 0) {
  //     const sizes = attributes
  //       ?.map((atributo) => {
  //         if (atributo?.nombre === 'Talle') {
  //           return atributo?.valor
  //         }
  //       })
  //       ?.filter((size) => size !== undefined)
  //     return sizes
  //   }
  // }

  return []
}

export const getColorsFromAttributes = (attributes = []) => {
  // if (attributes?.length) {
  //   if (attributes.length > 0) {
  //     const colors = attributes
  //       ?.map((atributo) => {
  //         if (atributo?.nombre === 'Color') {
  //           return atributo?.valor
  //         }
  //       })
  //       ?.filter((item) => item !== undefined)
  //     return colors
  //   }
  // }

  return []
}
